<template>
  <b-card title="View PCode">
    <b-row>
      <b-col cols="12">
        <b-form>
          <b-form-group
              description="PCode Name"
            >
            <label>Name</label>
              <b-form-input
                v-model="form.name"
                type="text"
                placeholder="Enter name"
                disabled
              ></b-form-input>
          </b-form-group>

             <label for="start-input">Validity Start</label>
            <b-input-group class="mb-3">
            <b-form-input
              id="start-input"
              v-model="form.validityStartInput"
              type="text"
              placeholder="DD-MM-YYYY"
              disabled
            ></b-form-input>
          </b-input-group>

            <label for="end-input">Validity End</label>
            <b-input-group class="mb-3">
            <b-form-input
              id="end-input"
              v-model="form.validityEndInput"
              type="text"
              placeholder="DD-MM-YYYY"
              disabled
            ></b-form-input>
          </b-input-group>

          <b-form-group
              description="Extension"
            >
            <label>Extension (Month)</label>
              <b-form-input
                id="input-credit"
                v-model="form.extension"
                type="text"
                placeholder="Enter Extension"
                disabled
              ></b-form-input>
          </b-form-group>

          <b-form-group
              description="Status"
            >
            <label>Status</label>
              <b-form-input
                v-model="form.status"
                type="text"
                disabled
              ></b-form-input>
          </b-form-group>
        </b-form>
      </b-col>

      <b-col cols="12" class="my-1">
        <b-form-group
              label="Model"
              description="Model List"
            >
        <b-form-textarea
          rows="6"
          max-rows="8"
          no-auto-shrink
          v-model="form.models"
          disabled></b-form-textarea>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-button @click="$router.go(-1)" type="button" variant="secondary">Back</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      form: {
        name: '',
        validityStartInput: "",
        validityStart: '',
        validityEndInput: "",
        validityEnd: '',
        extension: '',
        status: '',
        models: "",
      }
    }
  },
  created() {
    this.getPCode(this.$route.params.id).then((data) => {
      let convert = data.models.toString().replace(/,/g,'\n')
      
      this.form = data;
      this.form.validityStart = data.validityStart.substr(0,10)
      var startTemp = this.form.validityStart.split('-');
      this.form.validityStartInput = startTemp[2]+"-"+startTemp[1]+"-"+startTemp[0]
      this.form.validityEnd = data.validityEnd.substr(0,10)
      var endTemp = this.form.validityEnd.split('-');
      this.form.validityEndInput = endTemp[2]+"-"+endTemp[1]+"-"+endTemp[0]
      
      this.form.models = convert;
    });
  },
  methods: {
    ...mapActions({
      'getPCode': 'pcode/getPCode',
    })
  }
}
</script>